import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  FormData: FormGroup;
  modalReference : any;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    nav: false,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    
  }
  productArray : any;
  modalTitle: any;
  modaltDescription:any;
  closeResult = '';
  constructor(private modalService: NgbModal, private builder: FormBuilder) { 
    console.log("Product constructor");
  }

  ngOnInit(): void {
    this.initialize();
    this.FormData = this.builder.group({
      user_name: new FormControl('', [Validators.required]),
      user_email: new FormControl('', [Validators.compose([Validators.required, Validators.email])]),
      user_number: new FormControl('',[Validators.compose([ Validators.required,Validators.pattern("^[0-9]*$"),Validators.minLength(10), Validators.maxLength(10)])]),
      user_subject: new FormControl('', [Validators.required]),
      user_message: new FormControl('', [Validators.required])
      })
  }

  initialize() {
    this.productArray = {
      "productList": [{
        "img" : "assets/img/product-1.png",
        "title" : "Capacitor Discharge ignition",
        "description": "We are master into the design of Capacitor Discharge ignition (CDI) (DC-DC CDI), Transistor Controlled ignition system (TCI) .Which are the technology used by all 2 and 3 wheeler OEM all over the world in the ignition system."
      },
      {
        "img" : "assets/img/product-2.png",
        "title" : "Immobilizer",
        "description": "We are master into the design of Immobilizer We are well adverse with Passive Key Less Entry (PKE) Remote Key Less Entry(RKE).Technology used by Indian Two Wheeler MFG. We can integrate the same with Ignition System. We have success story in Indian Automotive Industry."
      },
      {
        "img" : "assets/img/product-3.png",
        "title" : "Digital Cluster",
        "description": "We have designed a wide range of Automotive clusters. Automotive clusters are differentiated in terms of the Display used, we have used a wide verity and range of display like segmented LCD, TFT display, touch screen display, all types of graphical displays are Incorporated in the cluster design as per the market requirements."
      },
      {
        "img" : "assets/img/product-4.png",
        "title" : "Internet of Things",
        "description": "oT can be used for many applications including : Agricultural, Industrial Automation, Home Automation, Automotive, Industrial Lighting, Highway Street Lighting"
      },{
        "img" : "assets/img/fes.jpg",
        "title" : "Functional Electrical Simulator (FES)",
        "description": "We have designed a FES system in the field of medical equipment. FES is a system which consists of a control box, with a battery and electrodes."
      },
      {
        "img" : "assets/img/small-ecu.jpg",
        "title" : "Small ECU",
        "description": "We have many of the small ECU for commercial vehicle, 2 & 3 wheeler which will take the input from CAN Line and perform the task as per customer requirement."
      },
      {
        "img" : "assets/img/smart-sensors.jpg",
        "title" : "Smart Sensors",
        "description": "All types of sensors like capacitance Fuel level Sensors, Speed sensors , Distance sensors , Smart Gear Sensors many of the sensors we have designed as per requirement"
      },
      {
        "img" : "assets/img/product-3.png",
        "title" : "EV Projets",
        "description": "BLDC Motor & Controller From 1Kw to 5Kw. Induction Motor Controller 5Kw."
      },
      {
        "img" : "assets/img/genset-iot.jpg",
        "title" : "Genset IoT",
        "description": "We have already successfully implemented this technology for Genset Application."
      },{
        "img" : "assets/img/agri-iot.jpg",
        "title" : "IoT in Agriculture",
        "description": "We have used Geo-fencing technology for spraying chemicals in farm. With exact parameters set, the sprayer does not spray chemicals beyond the set boundary."
      },{
        "img" : "assets/img/smart-city.jpg",
        "title" : "IoT for Smart Cities",
        "description": "Smart city needs smart solutions, With IoT used for these smart dust beans wet waste and dry waste is identified correctly and if waste is wrongly disposed then it is returned back to user for disposal in correct compartment."
      },{
        "img" : "assets/img/home-auto.jpg",
        "title" : "Home Automation",
        "description": "We have a expertise in using many of the wireless modules like WiFi , Bluetooth, Zigbee , IR remote, GSM , GPS and GPRS modules and also we have ability to design all typed of display."
      },{
        "img" : "assets/img/audio-system.jpg",
        "title" : "Audio System",
        "description": "ASIC Development Cost Competitive Audio System for Automotive In built FM + MP3 + Aux + SD Card p + LCD Driver. Product Image 25W + 25W Class AB Amplifier. IR Remote (Standard Part Paired with Unit) System Level Integration at Customer"
      },{
        "img" : "assets/img/telematics.jpg",
        "title" : "Telematics Products",
        "description": "Designed for Automotive Application High Accuracy Vehicle Tacking System AIS410. GPS Tracker Sports and Personal Application Designed for Automotive Application. Basic Vehicle Tacking System Suitable For Two & Three Wheeler applic"
      }]
    }
  }

  open(content) { //open(content,product) for product
    // this.modalTitle = product.title;
    // this.modaltDescription = product.description;
    this.modalReference = this.modalService.open(content);
    // this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  public sendEmail(e: Event) {
    e.preventDefault();
    emailjs.sendForm('service_9q6nx6t', 'template_j9pzm3q', e.target as HTMLFormElement, 'user_Nta3Via2yHAqITmxyMgjm')
      .then((result: EmailJSResponseStatus) => {
        console.log(result.text);
        this.FormData.reset();
        this.modalReference.close();
      }, (error) => {
        console.log(error.text);
      });
  }

}
